export const FETCH_FILES = "fetchData";
export const FETCH_MULTIPLE_FILES_BY_RELEASE = "fetchMultipleByRelease";
export const FETCH_MULTIPLE_FILES_BY_SOURCE = "fetchMultipleBySource";
export const RESET_DATA_STORAGE = "resetDataStorage";
